export type SCRequestCodeDialogStep = '1_REQUEST_CODE_STEP' | '2_RECAPCHA_STEP' | '3_RECEIVED_CODE_STEP'

export enum PostalCodeStepsEnum {
  REQUEST_CODE_STEP_1 = '1_REQUEST_CODE_STEP',
  RECAPCHA_STEP_2 = '2_RECAPCHA_STEP',
  SCRATCH_STEP_3 = '3_SCRATCH_STEP',
  RECEIVED_CODE_STEP_4 = '4_RECEIVED_CODE_STEP',
  LOADING = 'LOADING',
}
